import { ChevronDownIcon } from 'lucide-react'

import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui'
import { monthSpanText } from '../portfolioText'
import { ReasonActionButton } from '../ReasonActionButton'
import type { ReviewGroup, ReviewStatement } from './reviewGroups'

const ReviewStatementRow = ({ statement }: { statement: ReviewStatement }) => (
  <li className="flex items-center justify-between gap-3 border-b px-2.5 py-2 last:border-b-0">
    <div className="min-w-0 text-xs">
      <div className="font-medium text-blue-7">{statement.accountName}</div>
      <div className="text-ink-subtle">
        {monthSpanText(statement.firstMonth, statement.lastMonth)}
      </div>
    </div>
    <ReasonActionButton action={statement.action} />
  </li>
)

const ReviewGroupLine = ({ group }: { group: ReviewGroup }) => (
  <li>
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="inline-flex cursor-pointer items-center gap-1 text-right text-xs text-ink-subtle hover:text-blue-7"
        >
          {group.line}
          <ChevronDownIcon className="size-3 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[420px] p-1.5">
        <ul className="m-0 max-h-80 list-none overflow-y-auto p-0">
          {group.statements.map((statement) => (
            <ReviewStatementRow key={statement.key} statement={statement} />
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  </li>
)

// One line per kind of problem. Each opens the statements behind it, with the button that helps.
export const ReviewReasons = ({ groups }: { groups: ReviewGroup[] }) => (
  <ul className="m-0 flex list-none flex-col items-end gap-0.5 p-0">
    {groups.map((group) => (
      <ReviewGroupLine key={group.kind} group={group} />
    ))}
  </ul>
)
